import { useQuery } from 'react-query'

import { CacheKeys } from '../../helpers/cacheKeys'
import { getReferrals } from '../../models/referral'

export function useReferrals(userId: string) {
  const { data, isLoading } = useQuery(`${CacheKeys.REFERRALS}-${userId}`, () => getReferrals(userId), {
    enabled: true,
    refetchOnWindowFocus: false,
    retry: false,
  })

  return {
    referrals: data,
    isLoading,
  }
}
